module.exports = __webpack_public_path__ + "static/media/telegramLight.4821e1ba.svg";